<template>
  <!-- Teleport out of the NavBar (sticky z-[5]) stacking context so the
       overlay's z-index competes at page level and covers the SideBar (z-20). -->
  <Teleport to="body">
    <BaseModal v-model="localModelValue" @close="closeModal" size="sm">
      <template #body>
        <div class="w-full flex flex-col items-center justify-center gap-3 py-5 px-2 text-center">
          <!-- آیکون هشدار — عمل تخریبی -->
          <span class="w-14 h-14 rounded-full bg-red-50 dark:bg-red-950/40 flex items-center justify-center">
            <IconLogout size="26" class="text-red-600 dark:text-red-400" />
          </span>

          <div class="flex flex-col gap-1">
            <h2 class="text-[16px] font-demiboldd text-font-dark tracking-tight leading-6">
              {{ t('user.logoutTitle') }}
            </h2>
            <p class="text-[13px] text-font-gray leading-6">
              {{ t('user.confirm') }}
            </p>
          </div>

          <div class="w-full flex items-center gap-2.5 pt-2">
            <BaseButton :is-icon-only="false" variant="danger" class="flex-1" @click="logoutAccount">
              {{ t('user.yes') }}
            </BaseButton>
            <BaseButton :is-icon-only="false" variant="outlines" class="flex-1" @click="closeModal">
              {{ t('user.no') }}
            </BaseButton>
          </div>
        </div>
      </template>
    </BaseModal>
  </Teleport>
</template>

<script lang="ts" setup>
import { ref, watch } from 'vue'
import BaseModal from '@/components/base/BaseModal.vue'
import BaseButton from '@/components/base/BaseButton.vue'
import { IconLogout } from '@tabler/icons-vue'
import { useI18n } from 'vue-i18n'

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  },
})

const localModelValue = ref(props.modelValue)
const { t } = useI18n()

const emit = defineEmits(['update:modelValue','logoutAcc'])

watch(
  () => props.modelValue,
  (newValue) => {
    localModelValue.value = newValue
  },
)

watch(localModelValue, (newValue) => {
  emit('update:modelValue', newValue)
})

const closeModal = () => {
  emit('update:modelValue', false)
}

const logoutAccount = () => {
  emit('logoutAcc')
  document.body.style.overflow = ''
}
</script>
